import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/Header';
import Footer from '../../../components/Footer';
import './PresencaEstrategicaPage.css';

const PresencaEstrategicaPage = () => {
  return (
    <>
      <Header />
      
      <div className="presenca-container">
        <div className="presenca-content">
          <div className="presenca-left">
            <div className="presenca-logo">
              <img src="/logo/Logo_Sem_Fundo.png" alt="Veridicus Logo" className="logo-img" />
              <h1 className="overlay-title">PRESENÇA ESTRATÉGICA EM ÓRGÃOS E CONSELHOS</h1>
            </div>
          </div>
          
          <div className="presenca-right">
            <div className="presenca-description">
              <p className="presenca-intro">
                Temos cobertura nacional para todos os órgãos públicos e conselhos profissionais do 
                país:
              </p>
              
              <ul className="presenca-services">
                <li>Juntas Comerciais de todos os Estados;</li>
                <li>Cartórios de Registro Civil e de Títulos e Documentos;</li>
                <li>Conselhos profissionais (OAB, CRM, CREA, CRC, etc.);</li>
                <li>Agências reguladoras (ANVISA, ANATEL, ANS, etc.);</li>
                <li>Receita Federal e Secretarias de Fazenda;</li>
                <li>Prefeituras e demais órgãos municipais.</li>
              </ul>
              
              <p>
                Com fluxos automatizados, todos os protocolos e processos são acompanhados em tempo real. A Veridicus organiza 
                documentos, monitora prazos críticos e notifica sobre exigências ou pendências. Isso garante que cada interação com 
                órgãos e conselhos seja executada de forma segura e ágil, com visibilidade completa e mínima intervenção manual.
              </p>
            </div>
            
            <div className="presenca-cta">
              <Link to="/fale-conosco" className="cta-button">
                Entre em contato
              </Link>
            </div>
          </div>
        </div>
        
        <div className="presenca-navigation">
          <Link to="/servicos/consultoria" className="nav-prev">
            ← CONSULTORIA EM REGULARIZAÇÕES E COMPLIANCE
          </Link>
          <Link to="/servicos/gestao-cadastros" className="nav-next">
            GESTÃO DE CADASTROS FISCAIS E SOCIETÁRIOS →
          </Link>
        </div>
      </div>
      
      <Footer />
    </>
  );
};

export default PresencaEstrategicaPage;